import axios from "axios";
import Swal from "sweetalert2";
import { getSessionStorageValue } from "./getInfoSignatory";

type Field = {
  id: string;
  text_value: string;
};

export type Fields = { fields: Field[] };

export async function cancelSignature(data: String) {
  const url = process.env.REACT_APP_API_BASEURL;
  const urlID = window.location.search;
  const urlParams = new URLSearchParams(urlID);
  const id = urlParams.get("id");

  const token = getSessionStorageValue("token_user");
  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${url}/sign/${id}/cancel`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error: any) {
    const errorMessage =
      error.response.data?.message ||
      error.response.data?.errors?.error ||
      "Tente novamente";
    console.error("Erro na solicitação:", error);
    Swal.fire({
      title: "Erro!",
      text: errorMessage,
      icon: "error",
      confirmButtonText: "OK",
      confirmButtonColor: "#355B94",
    });
  }
}
